import { sanityClient } from "./client";
import * as queries from "./queries";

export type FilteredPostsParams = {
  search?: string;
  category?: string;
  dateRange?: [string, string] | [];
  sortBy?: string;
};

export const sanityApi = {
  fetchCategoriesWithPosts: async () => {
    return await sanityClient.fetch(queries.CATEGORIES_WITH_POSTS_QUERY);
  },

  fetchReferenzen: async () => {
    return await sanityClient.fetch(queries.REFERENZEN_QUERY);
  },

  fetchBeitraege: async () => {
    return await sanityClient.fetch(queries.POSTS_QUERY);
  },

  fetchCategories: async () => {
    return await sanityClient.fetch(queries.CATEGORIES_QUERY);
  },

  fetchNavbarBeitraege: async () => {
    return await sanityClient.fetch(queries.NAVBAR_BEITRAEGE_QUERY);
  },

  fetchNavbarVerkaufenTipps: async () => {
    return await sanityClient.fetch(queries.NAVBAR_VERKAUFEN_TIPPS_QUERY);
  },

  fetchNavbarKaufenTipps: async () => {
    return await sanityClient.fetch(queries.NAVBAR_KAUFEN_TIPPS_QUERY);
  },

  fetchNavbarVermietenTipps: async () => {
    return await sanityClient.fetch(queries.NAVBAR_VERMIETEN_TIPPS_QUERY);
  },

  fetchPostBySlug: async (slug: string) => {
    if (!slug) throw new Error("Slug is required");
    return await sanityClient.fetch(queries.POST_BY_SLUG_QUERY, { slug });
  },

  fetchFilteredPosts: async ({
    search = "",
    category = "",
    dateRange = [],
    sortBy = "publishedAt",
  }: FilteredPostsParams) => {
    const filters = [];
    if (search) {
      filters.push(`title match "${search}*" || body match "${search}*"`);
    }
    if (category) {
      filters.push(`category->name == "${category}"`);
    }
    if (dateRange && dateRange.length === 2) {
      filters.push(
        `publishedAt >= "${dateRange[0]}" && publishedAt <= "${dateRange[1]}"`
      );
    }

    const filterString = filters.length ? `&& ${filters.join(" && ")}` : "";
    const query = `*[_type == "estatePost" ${filterString}] | order(${sortBy} desc) ${queries.FILTERED_POSTS_PROJECTION}`;

    return await sanityClient.fetch(query);
  },

  // ====== CITY PAGES API ======

  /**
   * Fetch all published city pages
   */
  fetchAllCityPages: async () => {
    return await sanityClient.fetch(queries.ALL_CITY_PAGES_QUERY);
  },

  /**
   * Fetch a single city page by slug
   */
  fetchCityPageBySlug: async (slug: string) => {
    if (!slug) throw new Error("Slug is required");
    return await sanityClient.fetch(queries.CITY_PAGE_BY_SLUG_QUERY, { slug });
  },

  /**
   * Fetch city pages for sitemap generation
   */
  fetchCityPagesForSitemap: async () => {
    return await sanityClient.fetch(queries.CITY_PAGES_SITEMAP_QUERY);
  },

  /**
   * Fetch city pages for footer
   */
  fetchFooterCityPages: async () => {
    return await sanityClient.fetch(queries.FOOTER_CITY_PAGES_QUERY);
  },
};
